import React from 'react';
import { connect } from 'react-redux';
import { Icon } from '@amzn/storm-ui';
import { bellRegular } from '@amzn/storm-ui-icons';
import { RootState } from 'src/app/store';
import {
  CommunicationsDrawerInfo,
  selectCommunicationsDrawerInfo,
} from '../../store/slice';
import { UtilitiesIconButton } from '../styles';
import { ErrorBoundary } from 'src/commons/components/ErrorBoundary';
import { MobileCommuCommunicationsDrawerPublisher } from 'src/commons/utils/metrics';
import { communicationsDrawerTaktId } from './constants';

const COMMUNICATIONS_PATH = '/communications/feed?entityId=';

export const WrappedAcesCommunicationsDrawer: React.VFC<{
  communicationsDrawerInfo?: CommunicationsDrawerInfo;
}> = ({ communicationsDrawerInfo }) => {
  if (!communicationsDrawerInfo) {
    return null;
  }

  return (
    <ErrorBoundary name="aces-dynamic-communications-drawer-mobile">
      <UtilitiesIconButton
        onClick={() => {
          MobileCommuCommunicationsDrawerPublisher.publishCounterMonitor(
            'Open',
            1,
          );
          window.location.assign(
            `${COMMUNICATIONS_PATH}${communicationsDrawerInfo.texts.entityId}`,
          );
        }}
        data-takt-id={communicationsDrawerTaktId}
        aria-label={communicationsDrawerInfo.texts.label}
      >
        <Icon type={bellRegular} size="lg" />
      </UtilitiesIconButton>
    </ErrorBoundary>
  );
};
const acesConnector = connect((state: RootState) => {
  return {
    communicationsDrawerInfo: selectCommunicationsDrawerInfo(state),
  };
});

export const ConnectedWrappedAcesCommunicationsDrawer = acesConnector(
  WrappedAcesCommunicationsDrawer,
);
